import React, { useState, useMemo, useCallback } from "react";
import useSWR from "swr";
import { TreeList } from "devextreme-react/tree-list";
import { Column, Lookup } from "devextreme-react/data-grid";
import { TabPanel, Item as TabItem } from "devextreme-react/tab-panel";
import { deadlineTypes } from "../variables";
import { apiBaseURL } from "../../../Utils/ProjectConstants";
import { useParams, useNavigate } from "react-router-dom";
import useFetch from "../../../Hooks/useFetch";
import List from "devextreme-react/list";
import { FileUploader } from "devextreme-react";
import POCommentForm from "./poCommentForm";
import ActionNotifications from "../../../Components/ActionNotifications";
import { Button } from "devextreme-react/button";
import handleDelPOComment from "../../../Utils/handleDEL/handleDelPOComment";

const RequestInfo = (requests) => {
  const isUserKristen = requests[0].isUserKristen;

  return (
    <>
      <TreeList dataSource={requests} wordWrapEnabled keyExpr="id">
        <Column dataField="deadlineDate" dataType="date" />
        <Column dataField="requestorContactNumber" />
        <Column dataField="purchaseType" visible={false}>
          <Lookup
            dataSource={deadlineTypes}
            displayExpr="text"
            valueExpr="value"
          />
        </Column>
        <Column dataField="urgencyJustification" />
        <Column dataField="billingCode" />
        <Column dataField="otherBilling" />
        <Column dataField="poAdditionalEmails" />
        <Column dataField="additionalInfo" />
      </TreeList>
    </>
  );
};

const VendorInfo = (vendor) => {
  return (
    <>
      <TreeList dataSource={vendor} wordWrapEnabled keyExpr="id">
        <Column dataField="vendorName" />
        <Column dataField="vendorContact" />
        <Column dataField="vendorEmail" />
        <Column dataField="vendorAddress" />
      </TreeList>
    </>
  );
};

const ShippingInfo = (shipping) => {
  const boolRender = (e) => {
    return e.text;
  };

  return (
    <>
      <TreeList dataSource={shipping} wordWrapEnabled keyExpr="id">
        <Column dataField="location" caption="Shipping Location" />
        <Column dataField="shippingAttn" />
        <Column
          dataField="provideShippingAccountOnPO"
          cellRender={boolRender}
        />
        <Column dataField="isInstallationRequired" cellRender={boolRender} />
        <Column dataField="installationRequirements" />
      </TreeList>
    </>
  );
};

const HistoryTab = (history) => {
  const statusTextRender = (e) => {
    switch (e.value) {
      case 0:
        return "New";
      case 1:
        return "Supervisor Approved";
      case 2:
        return "Business Manager Approved";
      case 3:
        return "With Legal";
      case 4:
        return "PO Entered";
      case 5:
        return "PO Sent to Vendor";
      case 7:
        return "Cancelled";
      case 8:
        return "On Hold";
      case 10:
        return "Action Requested";
      case 11:
        return "Action Provided";
      default:
        return null;
    }
  };

  return (
    <>
      <TreeList dataSource={history} wordWrapEnabled>
        <Column dataField="date" dataType="datetime" defaultSortOrder="desc" />
        <Column dataField="changedBy" />
        <Column dataField="status" cellRender={statusTextRender} />
        <Column dataField="comment" />
      </TreeList>
    </>
  );
};
const CommentTab = (
  allPOComments,
  poOrderId,
  commentReponse,
  setCommentResponse,
  mutate,
  fetch,
) => {
  const [showPopup, setPopup] = useState({
    poCommentForm: null,
  });
  const handlePopup = useCallback((popupKey, data) => {
    console.log("handlePopup data", data);
    setPopup((prevState) => ({
      ...prevState,
      [popupKey]: { data },
    }));
  }, []);
  const handleClose = (popupKey) => {
    setPopup((prevState) => ({
      ...prevState,
      [popupKey]: null,
    }));
  };
  const handleDeleteComment = async (commentId) => {
    const { response, isDataGood } = await handleDelPOComment(
      poOrderId,
      commentId,
      fetch,
    );
    setCommentResponse(response);
    if (isDataGood) {
      mutate && mutate();
    }
  };
  return (
    <>
      <ActionNotifications response={commentReponse} />
      {showPopup.poCommentForm && (
        <POCommentForm
          poOrderId={poOrderId}
          setNotifications={setCommentResponse}
          onClose={() => handleClose("poCommentForm")}
          mutate={mutate}
        />
      )}
      <div
        style={{
          margin: "10px 0px 10px 0px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
        }}
      >
        <Button
          text="Add Comments"
          type="normal"
          stylingMode="contained"
          icon="add"
          onClick={() => handlePopup("poCommentForm", poOrderId)}
        />
      </div>
      <TreeList dataSource={allPOComments} wordWrapEnabled keyExpr="id">
        <Column
          caption="Actions"
          cellRender={(cellData) => (
            <Button
              icon="trash"
              stylingMode="text"
              onClick={() => handleDeleteComment(cellData.data.id)}
            />
          )}
        />
        <Column dataField="id" caption="Shipping Location" visible={false} />
        <Column
          dataField="date"
          caption="Date"
          dataType="datetime"
          defaultSortOrder="desc"
        />
        <Column dataField="name" caption="Name" />
        <Column dataField="comment" caption="Comment" />
      </TreeList>
    </>
  );
};
export default function InfoTab({
  poDetail,
  isUserKristen,
  mutate,
  fetchSuccessful,
}) {
  const params = useParams(),
    navigate = useNavigate(),
    fetch = useFetch(navigate),
    vendor = [
      {
        id: 1,
        vendorName: poDetail?.vendorName,
        vendorContact: poDetail?.vendorContact,
        vendorEmail: poDetail?.vendorEmail,
        vendorAddress: poDetail?.vendorAddress,
      },
    ],
    request = [
      {
        id: 1,
        isUserKristen: isUserKristen,
        deadlineDate: poDetail?.deadlineDate,
        requestorContactNumber: poDetail?.requestorContactNumber,
        urgencyJustification: poDetail?.urgencyJustification,
        purchaseType: poDetail?.purchaseType,
        billingCode: poDetail?.billingCode,
        otherBilling: poDetail?.otherBilling,
        poAdditionalEmails: poDetail?.poAdditionalEmails,
        additionalInfo: poDetail?.additionalInfo,
      },
    ],
    shipping = [
      {
        id: 1,
        location: poDetail?.shippingLocation?.location,
        shippingAttn: poDetail?.shippingAttn,
        provideShippingAccountOnPO: poDetail?.provideShippingAccountOnPO,
        isInstallationRequired: poDetail?.isInstallationRequired,
        installationRequirements: poDetail?.installationRequirements,
      },
    ],
    history = poDetail?.history?.reverse(),
    comments = poDetail?.comments?.reverse();

  const [commentResponse, setCommentResponse] = useState(null);
  const { data: quoteData } = useSWR(
      `${apiBaseURL}/api/attachment?purchaseOrderId=${poDetail.id}`,
    ),
    quotes = useMemo(
      () => quoteData?.data?.map((x) => ({ id: x.id, url: x.url })),
      [quoteData],
    );

  const [quoteDocument, setQuoteDocument] = useState("");

  const attachmentsTab = () => {
    const itemRender = (e) => {
      return (
        <a
          className="hoverLinkText yellow mx-2"
          href={"https://atlasboard.wsu-idp.org/backend" + e.url}
          target="_blank"
          rel="noreferrer"
        >
          {e.url}
        </a>
      );
    };

    const onItemDeleted = async (e) => {
      let response = await fetch.delete(
        `${apiBaseURL}/api/attachment?id=${e.itemData.value}`,
      );
      if (fetchSuccessful(response)) {
        mutate && mutate();
      }
    };

    const onFilesUploaded = async (event) => {
      console.log(event);
      const fileObj = event.component._files.map((x) => x.value);
      console.log(fileObj);
      if (!fileObj) {
        return;
      }

      for (let i = 0; i < quoteDocument.length; i++) {
        let formData = new FormData();
        formData.append("OrderId", poDetail?.id);
        formData.append("Image", quoteDocument[i]);
        let quoteResponse = await fetch.postFile(
          `https://atlasboard.wsu-idp.org/backend/api/attachment`,
          formData,
        );
        console.log(quoteResponse);
        if (fetchSuccessful(quoteResponse)) {
          mutate && mutate();
          setQuoteDocument("");
        }
      }
    };

    return (
      <>
        <div className="tabpanel">
          {quotes.length === 0 ? (
            <h6 className="noBold">No files uploaded.</h6>
          ) : (
            <List
              dataSource={quotes}
              height={140}
              itemDeleteMode="static"
              itemRender={itemRender}
              onItemDeleted={onItemDeleted}
            />
          )}
          <FileUploader
            selectButtonText="Upload Attachment"
            uploadMode="useForm"
            multiple
            showFileList={false}
            onValueChange={async (event) => {
              if (!event || event.length === 0) return;

              for (let i = 0; i < event.length; i++) {
                let formData = new FormData();
                formData.append("OrderId", poDetail?.id);
                formData.append("Image", event[i]);

                try {
                  const quoteResponse = await fetch.postFile(
                    `${apiBaseURL}/api/attachment`,
                    formData,
                  );
                  if (fetchSuccessful(quoteResponse)) {
                    console.log("Attachment uploaded:", event[i].name);
                    mutate && mutate();
                  } else {
                    console.error("Upload failed:", quoteResponse);
                  }
                } catch (err) {
                  console.error("Upload error:", err);
                }
              }
            }}
          />
        </div>
      </>
    );
  };

  return (
    <TabPanel>
      <TabItem title="Request Info" render={() => RequestInfo(request)} />
      <TabItem title="Vendor Info" render={() => VendorInfo(vendor)} />
      <TabItem title="Shipping Info" render={() => ShippingInfo(shipping)} />
      <TabItem title="Attachments" render={attachmentsTab} />
      <TabItem title="History" render={() => HistoryTab(history)} />
      <TabItem
        title="Comments"
        render={() =>
          CommentTab(
            comments,
            poDetail?.id,
            commentResponse,
            setCommentResponse,
            mutate,
            fetch,
          )
        }
      />
    </TabPanel>
  );
}
